document.addEventListener('DOMContentLoaded', function () {
  const timeline = document.querySelector('.timeline::before'); // timelineのセンターのラインを選択
  const timelineItems = document.querySelectorAll('.timeline-item');
  
  const observerOptions = {
    root: null, // viewport
    rootMargin: '0px',
    threshold: 0.2 // 20% 以上見える場合アニメーション実行
  };

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target); // すでに見えてたらもう観察しない
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  timelineItems.forEach(item => {
    observer.observe(item); // 各項目を観察
  });
  

});